export default "__VITE_PUBLIC_ASSET__0e979ee0__"